module.exports = __webpack_public_path__ + "img/new1-3.4086ab6b.png";